///<reference path="commonjs.d.ts"/>
require("./schemes/http");
require("./schemes/urn");
require("./schemes/mailto");



// WEBPACK FOOTER //
// node_modules/uri-js/build/schemes.js